// Guards the one page reload that recovers a tab whose build's hashed chunks 404 after a deploy.
// The reload time sits in sessionStorage so a chunk still missing afterwards fails normally instead of
// looping; when sessionStorage cannot be written nothing could stop a loop, so no reload happens.

export const STALE_CHUNK_RELOAD_KEY = 'stale_chunk_reload_at'
export const STALE_CHUNK_RELOAD_COOLDOWN_MS = 60_000

/**
 * Records a reload attempt at `now` and returns true when the caller may reload; false when one
 * already happened inside the cooldown or the attempt cannot be recorded.
 */
export const claimStaleChunkReload = (storage: () => Storage, now: number): boolean => {
  try {
    const store = storage()
    const lastAttempt = Number(store.getItem(STALE_CHUNK_RELOAD_KEY))
    if (lastAttempt && now - lastAttempt < STALE_CHUNK_RELOAD_COOLDOWN_MS) return false
    store.setItem(STALE_CHUNK_RELOAD_KEY, String(now))
    return true
  } catch {
    return false
  }
}
